// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__cVV_0","hide":"styles_hide__39Ukl","show":"styles_show__9s60E"};